export const isLandscape = () => {
    return window.innerWidth > window.innerHeight;
}

export const isMobileScreenResolution = () => {
    return window.innerWidth <= 1280;
  }